/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_CandadoGestor as CandadoGestor,
  rec_ConversacionesGestor as ConversacionesGestor,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_VincularMiNumero as VincularMiNumero,
  rec_api as api,
  rec_ii as ii,
} from "../../runtime/index.jsx";
export function GestorWhatsApp() {
  let e = (0, ReactCompiler.c)(13),
    [t, n] = (0, React.useState)(null),
    [r, i] = (0, React.useState)(!1),
    [a, o] = (0, React.useState)(``),
    [s, c] = (0, React.useState)(null),
    l;
  e[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((l = async () => {
        o(``);
        try {
          n(
            await api(`/gestor`, {
              sinCache: !0,
            }),
          );
        } catch (e) {
          let t = e;
          t.status === 404 ? i(!0) : o(t.message);
        }
      }),
      (e[0] = l))
    : (l = e[0]);
  let u = l,
    f,
    p;
  if (
    (e[1] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((f = () => {
          u();
        }),
        (p = [u]),
        (e[1] = f),
        (e[2] = p))
      : ((f = e[1]), (p = e[2])),
    (0, React.useEffect)(f, p),
    r)
  ) {
    let t;
    return (
      e[3] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((t = <AccesoDenegado />), (e[3] = t))
        : (t = e[3]),
      t
    );
  }
  let m;
  e[4] === t
    ? (m = e[5])
    : ((m = t && !t.vinculado && <VincularMiNumero />), (e[4] = t), (e[5] = m));
  let h;
  e[6] !== a || e[7] !== t || e[8] !== s
    ? ((h = a ? (
        <EstadoError mensaje={a} onReintentar={u} />
      ) : t ? (
        s ? (
          <ConversacionesGestor llave={s} onCerrar={() => c(null)} />
        ) : (
          <CandadoGestor
            estado={t}
            onAbierto={(e) => {
              (c(e),
                n({
                  ...t,
                  pinConfigurado: !0,
                }));
            }}
          />
        )
      ) : (
        <div
          className={`flex justify-center py-16 text-(--text)`}
          children={(0, JSXRuntime.jsx)(ii, {
            className: `h-6 w-6 animate-spin`,
          })}
        />
      )),
      (e[6] = a),
      (e[7] = t),
      (e[8] = s),
      (e[9] = h))
    : (h = e[9]);
  let _;
  return (
    e[10] !== m || e[11] !== h
      ? ((_ = (
          <EstructuraPrincipal
            title={`WhatsApp`}
            accionesRapidas={!1}
            children={[m, h]}
          />
        )),
        (e[10] = m),
        (e[11] = h),
        (e[12] = _))
      : (_ = e[12]),
    _
  );
}
